<template>
  <div>
  <div v-if="!json.init" class="spe_static_code" :id="`spe_static_code_${idName}`" v-html="data.htmlCode" :ddt-area="`component_${json.floorId}`" ddt-expose="on"></div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
export default {
  props: {
    json: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      data: {},
      idName: ''
    }
  },
  created() {
    this.idName = this.getRandom()
  },
  watch: {
    json: {
      handler(newVal, oldVal) {
        this.data = newVal.data
        let data = newVal.data
        this.$nextTick(() => {
          let spe_static_code = document.getElementById(`spe_static_code_${this.idName}`)
          for(let i=0 ; i<data.jsCodeList.length ; i++) {
            let script = document.createElement('script')
            script.type = 'text/javascript'
            script.innerHTML = data.jsCodeList[i]
            spe_static_code.appendChild(script)
          }
          this.changeJump()
        })
      },
      deep: true
    }
  },
  methods: {
    // 将a标签上的href元素改为事件跳转
    changeJump() {
      let list = document.getElementById(`spe_static_code_${this.idName}`).getElementsByTagName('a')
      for(let i=0 ; i<list.length ; i++) {
        let href = list[i].href
        if(href.indexOf('javascript:') == -1) {
          list[i].removeAttribute('href')
          list[i].addEventListener('click', () => {
            this.$sys.dict.href(href)
          })
        }
      }
    },
    getRandom() {
      return Math.round(Math.random()*1000000)
    }
  }
}
</script>

<style lang="less" scoped>
.spe_static_code {
  max-width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
</style>
